/** A simple timer to get the time elapsed since the timer was created. */
export class Timer {
  private readonly startTime: number;

  constructor() {
    this.startTime = Date.now();
  }

  msElapsed(): number {
    return Date.now() - this.startTime;
  }

  secondsElapsed(): number {
    return this.msElapsed() / 1000;
  }
}
